var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgressComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008187",
    fillRule: "evenodd",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm5.819 6.75c-.155 0-.295.046-.419.138l-7.588 7.496L6.6 11.165c-.124-.092-.264-.138-.419-.138-.155 0-.28.046-.372.138l-.42.368c-.092.123-.139.26-.139.414 0 .153.047.276.14.368l4.003 4.001c.124.123.264.184.42.184.154 0 .278-.061.371-.184l8.426-8.232c.093-.092.14-.215.14-.368s-.047-.291-.14-.414l-.419-.368c-.093-.123-.217-.184-.372-.184z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressComplete);
export default __webpack_public_path__ + "static/media/progress-complete.f211fd5a3bd59c6a6f296ca6b3596196.svg";
export { ForwardRef as ReactComponent };